// extracted by mini-css-extract-plugin
export default {"wrapper":"tp-z","response":"up-z","error":"vp-z","disabled":"wp-z","buttons":"xp-z","feedbackQuestionSection":"yp-z","yesNoWrapper":"zp-z"};